require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "gd": {
        "categories": {
          "cardinal": ["one", "two", "few", "other"],
          "ordinal": ["one", "two", "few", "other"]
        },
        "fn": function fn(n, ord) {
          var s = String(n).split('.'),
              t0 = Number(s[0]) == n;
          if (ord) return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : n == 3 || n == 13 ? 'few' : 'other';
          return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? 'few' : 'other';
        }
      }
    },
    "aliases": {},
    "parentLocales": {},
    "availableLocales": ["gd"]
  });
}